<button 
  (click)="toggleHandler()"
  class="bg-primary hover:bg-primary/80 w-[52px] h-[30px] text-sm text-center rounded-full items-center justify-center text-white p-1"
 
  [ngStyle]="{
    backgroundColor: (value && !disabled)
      ? 'color-mix(in oklch,var(--primary) 30%,transparent)'
      : '#6C757D',
    opacity: disabled ? 0.5 : 1
  }"
  [disabled]="disabled"
>
  <div
    class="relative transition-all bg-primary rounded-full h-6 w-6 top-[0px]"
    [ngStyle]="{
      right: value ? '-18px' : '0px'
    }"
  ></div>
</button>
